<section class="occupancy">
  <h3>{{ heading() | translate }}</h3>
  @if (objectCount() != null) {
    <p class="occupancy__total">{{ objectCount() }} {{ 'Objects' | translate }}</p>
  }
  @if (rows().length) {
    <div class="occupancy__stack" aria-hidden="true">
      @for (row of rows(); track row.id) {
        <span
          class="occupancy__segment"
          [style.flex-grow]="row.sharePercent || 0.1"
          [style.background]="row.color"
        ></span>
      }
    </div>
    <ul class="occupancy__list">
      @for (row of rows(); track row.id) {
        <li class="occupancy__item">
          @if (row.children.length) {
            <details [open]="row.id === openId()">
              <summary>
                <span class="occupancy__swatch" [style.background]="row.color"></span>
                <span class="occupancy__label">{{ row.label | translate }}</span>
                <span class="occupancy__meta">
                  {{ row.sizeLabel }}
                  @if (row.objectCount != null) {
                    · {{ row.objectCount }} {{ 'Objects' | translate }}
                  }
                  · {{ row.sharePercent }}%
                  @if (row.hint) {
                    · {{ row.hint | translate }}
                  }
                </span>
              </summary>
              <ul class="occupancy__children">
                @for (child of row.children; track child.id) {
                  @if (child.children.length) {
                    <li>
                      <details>
                        <summary class="occupancy__nested-summary">
                          <span class="occupancy__label">{{ child.label | translate }}</span>
                          <span class="occupancy__meta">
                            {{ child.sizeLabel }} · {{ child.sharePercent }}%
                            @if (child.hint) {
                              · {{ child.hint | translate }}
                            }
                          </span>
                        </summary>
                        <ul class="occupancy__grandchildren">
                          @for (table of child.children; track table.id) {
                            <li>
                              <span class="occupancy__label">{{ table.label | translate }}</span>
                              <span class="occupancy__meta">{{ table.sizeLabel }} · {{ table.sharePercent }}%</span>
                            </li>
                          }
                        </ul>
                      </details>
                    </li>
                  } @else {
                    <li>
                      <span class="occupancy__label">{{ child.label | translate }}</span>
                      <span class="occupancy__meta">
                        {{ child.sizeLabel }} · {{ child.sharePercent }}%
                        @if (child.hint) {
                          · {{ child.hint | translate }}
                        }
                      </span>
                    </li>
                  }
                }
              </ul>
            </details>
          } @else {
            <div class="occupancy__leaf">
              <span class="occupancy__swatch" [style.background]="row.color"></span>
              <span class="occupancy__label">{{ row.label | translate }}</span>
              <span class="occupancy__meta">
                {{ row.sizeLabel }}
                @if (row.objectCount != null) {
                  · {{ row.objectCount }} {{ 'Objects' | translate }}
                }
                · {{ row.sharePercent }}%
                @if (row.hint) {
                  · {{ row.hint | translate }}
                }
              </span>
            </div>
          }
        </li>
      }
    </ul>
  }
</section>
